import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { trackCTA } from '../utils/analytics';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../i18n/content';

const CTA = () => {
  const { language } = useLanguage();
  const t = content[language].cta;
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start end", "end end"]
  });

  const scale = useTransform(scrollYProgress, [0, 1], [0.5, 1]);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [0, 1]);
  const y = useTransform(scrollYProgress, [0, 1], [100, 0]);

  const handleWhatsApp = () => {
    const phoneNumber = '50379009458'; // WhatsApp number without +
    const message = encodeURIComponent(t.whatsappMessage);
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <section id="contact" ref={targetRef} className="min-h-[120vh] flex items-center px-4 relative premium-bg-1">
      <div className="container mx-auto max-w-5xl relative z-10 premium-content-layer">
        <motion.div 
          className="text-center flex flex-col items-center justify-center"
          style={{ scale, opacity, y }}
        >
          <h2 className="font-display text-4xl md:text-6xl lg:text-[5.5rem] font-bold mb-8 leading-[1.1] tracking-tighter drop-shadow-2xl">
            <span className="text-white block">{t.titleLine1}</span>
            <span className="text-secondary block">{t.titleLine2}</span>
          </h2>

          <p className="text-xl md:text-3xl text-white/80 font-light mb-12 max-w-3xl mx-auto leading-relaxed">
            {t.subtitle}
          </p>

          <motion.div
            onClick={() => {
              handleWhatsApp();
              trackCTA('final_cta_price_tag', 'Diagnóstico sin costo, sin compromiso');
            }}
            className="text-xl md:text-2xl font-bold text-white mb-10 bg-white/5 px-8 py-4 rounded-full border border-white/10 backdrop-blur-md shadow-xl cursor-pointer hover:bg-white/10 hover:border-secondary/30 transition-all duration-300"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <span className="text-secondary">{t.pillPart1}</span> {t.pillPart2}
          </motion.div>

          <motion.button
            onClick={() => {
              handleWhatsApp();
              trackCTA('final_cta_button', 'Agendar diagnóstico por WhatsApp');
            }}
            className="px-8 md:px-12 py-5 md:py-6 bg-secondary text-white font-label font-bold text-xl md:text-2xl rounded-full shadow-[0_0_40px_rgba(0,123,255,0.4)] hover:shadow-[0_0_60px_rgba(0,123,255,0.6)] transition-all duration-300 inline-flex items-center gap-4"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span>{t.button}</span>
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;

